import { useLocation } from 'react-router-dom'

interface CheckPathFunc {
  (target: string): boolean
}

const usePathMatcher = () => {
  const pathSet = useLocation().pathname.slice(1).split('/')

  const isIncludePath: CheckPathFunc = (target) => {
    return pathSet.includes(target)
  }
  const isStartPath: CheckPathFunc = (target) => {
    return pathSet[0] === target
  }
  const isEndPath: CheckPathFunc = (target) => {
    return pathSet[pathSet.length - 1] === target
  }

  return { isIncludePath, isStartPath, isEndPath }
}

export default usePathMatcher
